import { Divider, Input } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { getAllJdsApi, getJdPreviewData } from "../../api/candidate";
import Utils from "../../utils/Utils";
import WebUtils from "../../utils/WebUtils";
import Loader from "../Loader";
import JdDetailsCard from "./JdDetailsCard";
import RequestAccess from "../requestAccess/RequestAccess";
import CreateJdModal from "./CreateJdModal";
import { Building } from "lucide-react";
import noJob from "../../assets/insight/noJobs.svg";
import noJobSelected from "../../assets/insight/noJobSelected.svg";

const userDetail = Utils.getUserDetail();

function InSightMain() {
  const [allJobs, setAllJobs] = useState(null);
  const [jdDetails, setJdDetails] = useState(null);
  const [localSearch, setLocalSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openCreateJdModal, setOpenCreateJdModal] = useState(false);

  // Filter jobs based on search term (case insensitive)
  const filteredJobs = allJobs?.filter((job) => {
    const lowerSearch = localSearch.toLowerCase();
    return (
      job?.jobTitle?.toLowerCase().includes(lowerSearch) ||
      job?.companyName?.toLowerCase().includes(lowerSearch) ||
      String(job?.yearsOfExperience)?.toLowerCase().includes(lowerSearch)
    );
  });

  const getAllJds = async () => {
    const url = `${getAllJdsApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;
    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setAllJobs(result.data.data);
        } else {
          setAllJobs(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getPreviewData = async (jdId) => {
    const url = `${getJdPreviewData}?jdIdentifier=${jdId}&userIdentifier=${userDetail?.userIdentifier}`;

    setSkeletonLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setSkeletonLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setJdDetails(result.data.data);
        } else {
          setJdDetails(null);
        }
      })
      .catch((err) => {
        setSkeletonLoading(false);
        console.log(err);
      });
  };
  const handleClick = (job) => {
    if (selectedId === job?.jdIdentifier) {
      // already selected → do nothing
      return;
    }
    setSelectedId(job?.jdIdentifier);
    getPreviewData(job?.jdIdentifier);
  };
  useEffect(() => {
    getAllJds();
  }, []);
  return (
    <>
      {loading && <Loader />}
      {openCreateJdModal && (
        <CreateJdModal
          openCreateJdModal={openCreateJdModal}
          setOpenCreateJdModal={setOpenCreateJdModal}
          getAllJds={getAllJds}
        />
      )}
      {allJobs?.length > 0 ? (
        <div className="flex lg:flex-row flex-col lg:h-[92vh] h-full">
          <div className="border-r-2 py-3 lg:w-[30%] w-full px-2 ">
            <p className="text-[#101828] font-semibold text-xl mt-3 px-6 ">
              Job list{" "}
            </p>
            <p className="text-[#475467] text-sm px-6 ">
              Select from job roles
            </p>

            <div className="mt-4 px-6 ">
              <Input
                size="large"
                prefix={<SearchOutlined style={{ color: "#999" }} />}
                placeholder="Search jobs or companies"
                allowClear
                value={localSearch}
                onChange={(e) => setLocalSearch(e.target.value)}
              />
            </div>
            <div className="mt-4 px-6">
              <button
                onClick={() => setOpenCreateJdModal(true)}
                className="btn-orange px-3 py-[.4rem] w-full flex items-center justify-center gap-x-2"
              >
                {" "}
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.5 1V15M1.5 8H15.5"
                    stroke="#0F1B23"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Add Job
              </button>
            </div>
            <div className="mt-5 lg:max-h-[63vh] sm:max-h-[40vh] max-h-[35vh]  overflow-y-auto orange-scroll px-6">
              {filteredJobs?.length > 0 ? (
                filteredJobs.map((job, index) => (
                  <div
                    onClick={() => {
                      handleClick(job);
                    }}
                    key={index}
                    className={`p-4 cursor-pointer rounded-lg border-2 mb-3 mt-1 transition duration-200 ease-in-out 
            ${
              selectedId === job?.jdIdentifier
                ? "bg-orange-50 border-orange-400"
                : "hover:bg-orange-50 hover:scale-105"
            }`}
                  >
                    <p className="text-lg text-[#101828] font-semibold">
                      {job?.jobTitle}
                    </p>
                    <p className="mt-2 text-[#EDC043] font-medium flex items-center gap-x-2">
                      <Building size={18} /> {job?.companyName}
                    </p>
                    <p className="text-[#475467] mt-2 font-medium flex items-center gap-x-2">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3346 4.83333C13.3346 4.05836 13.3346 3.67087 13.2494 3.35295C13.0183 2.49022 12.3444 1.81635 11.4817 1.58519C11.1638 1.5 10.7763 1.5 10.0013 1.5C9.22633 1.5 8.83884 1.5 8.52092 1.58519C7.65819 1.81635 6.98432 2.49022 6.75315 3.35295C6.66797 3.67087 6.66797 4.05836 6.66797 4.83333M4.33464 16.5H15.668C16.6014 16.5 17.0681 16.5 17.4246 16.3183C17.7382 16.1586 17.9932 15.9036 18.153 15.59C18.3346 15.2335 18.3346 14.7668 18.3346 13.8333V7.5C18.3346 6.56658 18.3346 6.09987 18.153 5.74335C17.9932 5.42975 17.7382 5.17478 17.4246 5.01499C17.0681 4.83333 16.6014 4.83333 15.668 4.83333H4.33464C3.40121 4.83333 2.9345 4.83333 2.57798 5.01499C2.26438 5.17478 2.00941 5.42975 1.84962 5.74335C1.66797 6.09987 1.66797 6.56658 1.66797 7.5V13.8333C1.66797 14.7668 1.66797 15.2335 1.84962 15.59C2.00941 15.9036 2.26438 16.1586 2.57798 16.3183C2.9345 16.5 3.40121 16.5 4.33464 16.5Z"
                          stroke="#667085"
                          stroke-width="1.67"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>{" "}
                      {job?.yearsOfExperience}+ years experience
                    </p>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500 mt-4">No jobs found</p>
              )}
            </div>
          </div>
          <Divider className="lg:hidden block border-gray-300" />
          <div className="px-4 py-3 lg:w-[70%] w-full">
            {jdDetails || skeletonLoading ? (
              <>
                <JdDetailsCard
                  jdDetails={jdDetails}
                  skeletonLoading={skeletonLoading}
                />
                <div className=" lg:mt-12 mt-4">
                  <RequestAccess
                    moduleName="IN_SIGHT"
                    svgSize="150"
                    noMaxHeight={true}
                  />
                </div>
              </>
            ) : (
              <div className="md:h-[90vh] h-auto flex flex-col justify-center items-center px-4">
                <img src={noJobSelected} />
                <div className="sm:max-w-[500px] max-w-full text-[#475467] text-center">
                  You haven’t chosen a job to explore. Select one from the
                  available list to view in-depth insights, trends, and
                  preparation guidance.
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="h-[90vh] flex flex-col items-center justify-center px-4">
          <img src={noJob} />
          <div className="text-[#475467] sm:max-w-[500px] max-w-full text-center mt-2">
            No jobs have been added or are available in the list. Please create
            a new job to explore detailed AI-powered insights.
          </div>
          <div className="mt-4 sm:w-[300px] w-full">
            <button
              onClick={() => setOpenCreateJdModal(true)}
              className="btn-orange px-3 py-[.4rem] w-full flex items-center justify-center gap-x-2"
            >
              {" "}
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.5 1V15M1.5 8H15.5"
                  stroke="#0F1B23"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Add Job
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default InSightMain;
